import { Link } from "react-router-dom";
import './style.css';
import LogoCompleto from '../../assets/logo.png';

const Unauthorized = () => {
    return (
        <div className="container_unauthorized">
            <img 
                src={LogoCompleto} 
                alt="Logo causale" 
                className="container_upper__logo" 
            />
            <h1>Acesso Negado</h1>
            <p>Você não tem permissão para acessar esta página.</p>
            <Link to="/">Voltar para o Login</Link>
        </div>
    );
}

export default Unauthorized;